import axios from 'axios'

import { EBAY_URL } from '@src/Core/Constants/RouteConstants'
import { ConnectorResult } from '@src/Infrastructure/Types/ConnectorResult'
import {
    GetTrackAndTraceError,
    GetTrackAndTraceParams,
    GetTrackAndTraceResponse,
    TrackAndTraceEvent,
} from '@src/Infrastructure/Types/GetTrackAndTrace'

export const GET_ECOMMERCE_TRACK_AND_TRACE_ENDPOINT = '/api/v1/ecommerce/track-and-trace/'

export const getTrackingEndpoint = (shipmentId: string): string => {
    return `${GET_ECOMMERCE_TRACK_AND_TRACE_ENDPOINT}${shipmentId}`
}

export const getTracking = async (
    params: GetTrackAndTraceParams
): Promise<ConnectorResult<TrackAndTraceEvent[], GetTrackAndTraceError>> => {
    try {
        const { data, status } = await axios.get<GetTrackAndTraceResponse>(getTrackingEndpoint(params.shipmentId), {
            baseURL: EBAY_URL,
        })

        if (status === 404) {
            return { errors: [{ code: 'SHIPMENT_NOT_FOUND' }] }
        }

        if (status !== 200) {
            return { errors: [{ code: 'INTERNAL_ERROR' }] }
        }

        return {
            data: data.data,
        }
    } catch (e) {
        return { errors: [{ code: 'UNKNOWN_ERROR' }] }
    }
}
